<template>
  <div class="contents mst_syounin_groups">
    <h2>有休付与新規登録</h2>

    <div class="container">
      <template v-if="isLoading">
        <loading :isLoading="isLoading" :message="'データ読み込み中...'"></loading>
      </template>

      <template v-else>
        <section>
          <h3>有休付与の設定</h3>

          <div class="input-area">
            <div class="form-item">
              <label class="title">社員番号</label>
              <label>{{ daichouInfo.staff_code }}</label>
            </div>

            <div class="form-item">
              <label class="title">氏名</label>
              <label>{{ daichouInfo.staff_name }}</label>
            </div>

            <div class="form-item">
              <label class="title required">有休付与日を指定して下さい</label>
              <date-picker v-model="daichouInfo.this_year_fuyo_date" :error="getError(daichouInfo, 'this_year_fuyo_date')" @update:modelValue="change"></date-picker>
            </div>

            <div class="form-item">
              <label class="title">次回付与日</label>
              <label>{{daichouInfo.next_year_fuyo_date}}</label>
            </div>

            <div class="form-item">
              <label class="title required">有休付与日数を指定して下さい</label>
              <input-text type="number" v-model="daichouInfo.konnen_fuyo_days" :error="getError(daichouInfo, 'konnen_fuyo_days')"></input-text>
            </div>

            <div class="form-item">
              <label class="title required">特別有休付与日数を指定して下さい</label>
              <input-text type="number" v-model="daichouInfo.tokubetsu_kyuuka" :error="getError(daichouInfo, 'tokubetsu_kyuuka')"></input-text>
            </div>

            <div class="form-item">
              <label class="title">前年度付与日</label>
              <label>{{daichouInfo.last_year_fuyo_date}}</label>
            </div>

            <div class="form-item">
              <label class="title required">前年度繰越日数を指定して下さい</label>
              <input-text type="number" v-model="daichouInfo.zennen_kurikoshi_days" :error="getError(daichouInfo, 'zennen_kurikoshi_days')"></input-text>
            </div>
          </div>
        </section>

      </template>
    </div>

    <div class="button-container">
      <p class="prev-page">
        <!-- <router-link :to="{
          name: RouterConst.YUUKYUU_KANRI_DETAIL,
        }">戻る
        </router-link> -->
      </p>
      <p class="btn-temporary-save">
        <button type="button" @click="createNewData" :disabled="isLoading || isCreating">
          <template v-if="isCreating">
            <i class="fa-solid fa-spinner fa-spin-pulse"></i>有休付与登録中…
          </template>
          <template v-else>
            <i class="fa-solid fa-floppy-disk"></i>有休付与登録
          </template>
        </button>
      </p>
    </div>

  </div>
</template>

<script lang="ts">

import { ref, computed, defineComponent, onMounted, Ref } from 'vue'
import { RouterConst } from '@/const/Router'
import { DialogService } from '@/service/DialogService';
import { SweetAlertResult } from 'sweetalert2';
import { KanriDaichouListData, GetDaichouInfoRes, DaichouInfoForNewForm } from "@/types/YuukyuuKanri";
import { DateUtil } from "@/utils/DateUtil";
import { useRoute } from "vue-router";
import { useInit } from "@/composable/yuukyuu/create/init";
import { useRouter } from 'vue-router';
import { useForm } from "@/composable/form/form";
import { useCreate } from '@/composable/yuukyuu/create/create';

export default defineComponent({
  setup() {
    // 初期化
    const route = useRoute()
    const { getDaichouInfo, isLoading, isError } = useInit()
    const router = useRouter()
    const { getError } = useForm();
    const { isCreating, create } = useCreate();

    const daichouInfo: Ref<DaichouInfoForNewForm> = ref({
        user_id: null,
        staff_code: null,
        staff_name: null,
        this_year_fuyo_date: null,
        next_year_fuyo_date: null,
        konnen_fuyo_days: 0,
        tokubetsu_kyuuka: 0,
        last_year_fuyo_date: null,
        zennen_kurikoshi_days: 0,
    })

    const daichouInfoRes: Ref<GetDaichouInfoRes> = ref({
        user_id: null,
        staff_code: null,
        staff_name: null,
        start_date: null,
        end_date: null,
        this_year_fuyo_date: null,
        konnen_fuyo_days: 0,
        yuukyuu_total: 0,
        tokubetsu_kyuuka: 0,
        zennen_kurikoshi_days: 0,
    })
    
    const thisYearFuyoDate = ref("");
    const nextYearFuyoDate = ref("");

    // const isLoading = ref(false)

    // const isCreating = ref(false)

    onMounted(async () => {
      // isLoading.value = true

      const userId = parseInt(route.params.id as string, 10);
      daichouInfoRes.value = await getDaichouInfo(userId);

      daichouInfo.value.user_id = daichouInfoRes.value.user_id;
      daichouInfo.value.staff_code = daichouInfoRes.value.staff_code
      daichouInfo.value.staff_name = daichouInfoRes.value.staff_name
      daichouInfo.value.this_year_fuyo_date = daichouInfoRes.value.this_year_fuyo_date
      daichouInfo.value.konnen_fuyo_days = daichouInfoRes.value.konnen_fuyo_days
      daichouInfo.value.tokubetsu_kyuuka = daichouInfoRes.value.tokubetsu_kyuuka
      daichouInfo.value.zennen_kurikoshi_days = daichouInfoRes.value.zennen_kurikoshi_days

      console.log('daichouInfo');
      console.log(daichouInfo);

      // isLoading.value = false
    })
    
    // 新規作成ボタンクリックイベント
    const createNewData = async () => {

      const dialogResult = await DialogService.question({
        text: '有休付与を新規登録しますか？',
        showCancelButton: true,
        confirmButtonText: '登録します',
        cancelButtonText: 'キャンセル',
      })
      
      if (!dialogResult.isConfirmed) {
        return
      }

      console.log(daichouInfo.value);

      let res = await create(daichouInfo);

      console.log('res');
      console.log(res);

      if(res && res.result == true){
        // 詳細画面へ遷移
        const userId = parseInt(route.params.id as string, 10);
        router.push({ name: RouterConst.YUUKYUU_KANRI_DETAIL, params: { code: userId } });
      } else {
        if(res && res.result == false && res.message){
          DialogService.error({
            text: res.message as string
          }, true);
        }
        
      }

    }

    // 付与日変更イベント
    const change = (() => {
      // let year = new Date(thisYearFuyoDate.value).getFullYear();
      // let month = new Date(thisYearFuyoDate.value).getMonth();
      // let day = new Date(thisYearFuyoDate.value).getDate();


      let year = new Date(daichouInfo.value.this_year_fuyo_date as string).getFullYear();
      let month = new Date(daichouInfo.value.this_year_fuyo_date as string).getMonth();
      let day = new Date(daichouInfo.value.this_year_fuyo_date as string).getDate();

      // 次回付与日を表示
      daichouInfo.value.next_year_fuyo_date = DateUtil.format(new Date(year + 1, month, day));

      // 前年度付与日を表示
      daichouInfo.value.last_year_fuyo_date = DateUtil.format(new Date(year - 1, month, day));
    });

    return {
      isLoading,
      isCreating,
      RouterConst,
      createNewData,
      thisYearFuyoDate,
      nextYearFuyoDate,
      change,
      daichouInfo,
      getError,
      create,
    }
  },
  components: {

  }
})
</script>

<style lang="scss" scoped>
@import "@scss/components/yuukyuu_fuyo_create.scss";
</style>
